import {Optional} from 'typescript-optional';

export class BaseCriteriaModel {
  status ? = 'ACTIVE';
  orderBy ? = 'guid';
  offset ? = 0;
  limit ? = 100;
  order ? = 'ASC';
  calcTotalRecords? =false;

  // public static convertOptionalStringToQueryParms(optionalString: Optional<string>, param: string): string {
  //   return optionalString.filter(x => x !== '').map(x => '&' + param + '=' + x).orElse('');
  // }
}
